import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import { formatDateTime } from '@/utils/filters'

Vue.use(ElementUI)

// 注册全局时间格式化 filter
Vue.filter('formatDateTime', formatDateTime)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
